module.exports = __webpack_public_path__ + "img/ecocat-water.b1e20b81.svg";